import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FaClinicMedical, FaHandHoldingMedical } from "react-icons/fa";
import { GiHealthPotion } from "react-icons/gi";
import { MdHealthAndSafety } from "react-icons/md";
import WOW from "wow.js";

const AiHealth = () => {
  const { t } = useTranslation();
  useEffect(() => {
    const wow = new WOW();
    wow.init();
  }, []);

  const cardsData = [
    {
      logo: <MdHealthAndSafety fill="#ffffff" size={60} />,
      title: t("aiHealth.providers.title"),
      description: t("aiHealth.providers.description")
    },
    {
      logo: <GiHealthPotion fill="#ffffff" size={60} />,
      title: t("aiHealth.pharmaceutical.title"),
      description: t("aiHealth.pharmaceutical.description"),
    },
    {
      logo: <FaHandHoldingMedical fill="#ffffff" size={60} />,
      title: t("aiHealth.medical.title"),
      description: t("aiHealth.medical.description"),
    },
    {
      logo: <FaClinicMedical fill="#ffffff" size={60} />,
      title: t("aiHealth.startups.title"),
      description: t("aiHealth.startups.description"),
    },
  ];

  return (
    <div className="section pb-10 mt-4 font-sans" id="diffrence" style={{ textAlign: "justify", textJustify: "auto" }}>
      <div>
        <p className="text-3xl lg:text-4xl text-[#EF3B3B] font-bold  font-geo text-center wow fadeInUp pt-4 mx-10">
          {t("aiHealth.title")}
        </p>
        <div className="flex flex-wrap justify-center mt-24 wow fadeInUp mx-10 lg:mx-24">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 gap-5">
            {cardsData.map((card, index) => (

                <div
                  className="group bg-white bg-opacity-10 shadow-2xl rounded-lg ring-1 ring-gray-500 transform hover:scale-105 transition-transform duration-500"
                  style={{ borderRadius: "20px" }}
                >
                  <div className="flex justify-center text-center p-6">
                    {card.logo}
                  </div>
                  <div className="px-4 py-2">
                    <h3 className="text-2xl font-geo  text-center text-[#EF3B3B] font-bold mb-2">
                      {card.title}
                    </h3>
                    <p className="text-[#ababab] text-center font-semibold text-md p-3">
                      {card.description}
                    </p>
                  </div>
                </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AiHealth;
